export const data = [
  //1
  {
    key: "c7-01",
    title: "아기 코알라는 무얼 먹지?",
    grade: "1권",
    cover: require("@data/assets/purple/book1/images/cover.jpg"),
    background: require("@data/assets/purple/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book1/sounds/page23.mp3"),
      title: "Nǐ māma zài nǎr?",
      caption: [
        "nǐ māma zài nǎr nǐ māma zài nǎr wǒ bù zhīdào wǒ bù zhīdào",
        "wū wū wū wū bié kū wū wū wū wū bié kū",
        "nǐ zài nǎr nǐ zài nǎr wǒ zài zhèr wǒ zài zhèr",
        "hā hā hā hā māma lái le hā hā hā hā māma lái le",
      ],
    },
    mov: {
      cn: "63d9c0d2e4ef020859e3d336754d3cc5_01",
      en: "26d0d84268a158a475eb28fbc079bbdc_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book1/images/img_P1-02.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_01.mp3"),
          word: "真可爱!|Zhēn kě’ài!",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-01.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_02.mp3"),
          word: "你妈妈在哪儿?|Nǐ māma zài nǎr?",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-04.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_03.mp3"),
          word: "我不知道。|Wǒ bù zhīdào.",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-03.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_04.mp3"),
          word: "我饿了。|Wǒ è le.",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-06.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_05.mp3"),
          word: "他吃什么呢?|Tā chī shénme ne?",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-05.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_06.mp3"),
          word: "你尝一尝。|Nǐ cháng yi cháng.",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-08.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_07.mp3"),
          word: "我不吃。|Wǒ bù chī.",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-09.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_08.mp3"),
          word: "别哭!|Bié kū!",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-10.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_09.mp3"),
          word: "你们等一等。|Nǐmen děng yi děng.",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-07.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_10.mp3"),
          word: "真可怜!|Zhēn kělián!",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-12.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_11.mp3"),
          word: "我想妈妈。|Wǒ xiǎng māma.",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-11.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_12.mp3"),
          word: "我的小宝宝,你在哪儿?|Wǒ de xiǎo bǎobǎo, nǐ zài nǎr?",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-14.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_13.mp3"),
          word: "我在这儿!|Wǒ zài zhèr!",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-13.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_14.mp3"),
          word: "妈妈来了!|Māma lái le!",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-16.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_15.mp3"),
          word: "好臭!|Hǎo chòu!",
        },
        {
          img: require("@data/assets/purple/book1/images/img_P1-15.png"),
          sound: require("@data/assets/purple/book1/sounds/KG01_W_16.mp3"),
          word: "真好吃!|Zhēn hǎochī!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book1/images/img_P1-02.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_01.mp3"),
        buttons: [
          { ch2: "Zhēn kě’ài!" },
          { ch: "真可爱!" },
          { ko: "정말 귀엽다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-01.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_02.mp3"),
        buttons: [
          { ch2: "Nǐ māma zài nǎr?" },
          { ch: "你妈妈在哪儿?" },
          { ko: "네 어머니는 어디 계시니?" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-04.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_03.mp3"),
        buttons: [
          { ch2: "Wǒ bù zhīdào." },
          { ch: "我不知道。" },
          { ko: "저는 모르겠어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-03.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_04.mp3"),
        buttons: [
          { ch2: "Wǒ è le." },
          { ch: "我饿了。" },
          { ko: "나는 배고파." },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-06.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_05.mp3"),
        buttons: [
          { ch2: "Tā chī shénme ne?" },
          { ch: "他吃什么呢?" },
          { ko: "그는 무엇을 먹습니까?" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-05.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ cháng yi cháng." },
          { ch: "你尝一尝。" },
          { ko: "먹어 봐." },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-08.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ bù chī." },
          { ch: "我不吃。" },
          { ko: "나는 안 먹어." },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-09.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_08.mp3"),
        buttons: [{ ch2: "Bié kū!" }, { ch: "别哭!" }, { ko: "울지 마!" }],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-10.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_09.mp3"),
        buttons: [
          { ch2: "Nǐmen děng yi děng." },
          { ch: "你们等一等。" },
          { ko: "너희들 좀 기다려라." },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-07.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_10.mp3"),
        buttons: [
          { ch2: "Zhēn kělián!" },
          { ch: "真可怜!" },
          { ko: "불쌍해!" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-12.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng māma." },
          { ch: "我想妈妈。" },
          { ko: "엄마가 보고 싶어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-11.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ de xiǎo bǎobǎo, nǐ zài nǎr?" },
          { ch: "我的小宝宝,你在哪儿?" },
          { ko: "우리 아기, 어디 있어?" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-14.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ zài zhèr!" },
          { ch: "我在这儿!" },
          { ko: "나 여기 있어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-13.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_14.mp3"),
        buttons: [
          { ch2: "Māma lái le!" },
          { ch: "妈妈来了!" },
          { ko: "엄마 왔다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-16.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_15.mp3"),
        buttons: [{ ch2: "Hǎo chòu!" }, { ch: "好臭!" }, { ko: "냄새나!" }],
      },
      {
        img: require("@data/assets/purple/book1/images/img_P1-15.png"),
        sound: require("@data/assets/purple/book1/sounds/KG01_W_16.mp3"),
        buttons: [
          { ch2: "Zhēn hǎochī!" },
          { ch: "真好吃!" },
          { ko: "정말 맛있어!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book1/sounds/KG01_W_01.mp3"),
          img: require("@data/assets/purple/book1/images/img_P1-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book1/sounds/KG01_W_04.mp3"),
          answer: [
            [require("@data/assets/purple/book1/images/img_P1-03.png"), true],
            [require("@data/assets/purple/book1/images/img_P1-09.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book1/sounds/KG01_W_13.mp3"),
          answer: [
            ["我在这儿!", true],
            ["我不吃。", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book1/pages/front.jpg"),
        sound: require("@data/assets/purple/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page04.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page06.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page08.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page10.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page12.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page14.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page16.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page18.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page20.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page22.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page23.jpg"),
        sound: require("@data/assets/purple/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book1/thumbnail/front.jpg"),
      require("@data/assets/purple/book1/thumbnail/page02.jpg"),
      require("@data/assets/purple/book1/thumbnail/page03.jpg"),
      require("@data/assets/purple/book1/thumbnail/page04.jpg"),
      require("@data/assets/purple/book1/thumbnail/page05.jpg"),
      require("@data/assets/purple/book1/thumbnail/page06.jpg"),
      require("@data/assets/purple/book1/thumbnail/page07.jpg"),
      require("@data/assets/purple/book1/thumbnail/page08.jpg"),
      require("@data/assets/purple/book1/thumbnail/page09.jpg"),
      require("@data/assets/purple/book1/thumbnail/page10.jpg"),
      require("@data/assets/purple/book1/thumbnail/page11.jpg"),
      require("@data/assets/purple/book1/thumbnail/page12.jpg"),
      require("@data/assets/purple/book1/thumbnail/page13.jpg"),
      require("@data/assets/purple/book1/thumbnail/page14.jpg"),
      require("@data/assets/purple/book1/thumbnail/page15.jpg"),
      require("@data/assets/purple/book1/thumbnail/page16.jpg"),
      require("@data/assets/purple/book1/thumbnail/page17.jpg"),
      require("@data/assets/purple/book1/thumbnail/page18.jpg"),
      require("@data/assets/purple/book1/thumbnail/page19.jpg"),
      require("@data/assets/purple/book1/thumbnail/page20.jpg"),
      require("@data/assets/purple/book1/thumbnail/page21.jpg"),
      require("@data/assets/purple/book1/thumbnail/page22.jpg"),
      require("@data/assets/purple/book1/thumbnail/page23.jpg"),
      require("@data/assets/purple/book1/thumbnail/page24.jpg"),
      require("@data/assets/purple/book1/thumbnail/page25.jpg"),
      require("@data/assets/purple/book1/thumbnail/page26.jpg"),
      require("@data/assets/purple/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c7-02",
    title: "늑대가 버린 것들",
    grade: "2권",
    cover: require("@data/assets/purple/book2/images/cover.jpg"),
    background: require("@data/assets/purple/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book2/sounds/page23.mp3"),
      title: "Gěi wǒ zhège wánjù, hǎo bu hǎo?",
      caption: [
        "wánjù wánjù zhège wánjù gěi wǒ zhège wánjù hǎo bu hǎo",
        "gěi nǐ gěi nǐ zhēn hǎowánr xièxie nǐ de lǐwù",
        "yīfu yīfu zhèxiē yīfu gěi wǒ zhèxiē yīfu hǎo bu hǎo",
        "gěi nǐ gěi nǐ zhēn piàoliang xièxie nǐ de lǐwù",
      ],
    },
    mov: {
      cn: "5d3208f4469ee0bded256d35b6e77836_02",
      en: "fca5a152af41608b332bdca2cf8f661b_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book2/images/img_P2-02.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_01.mp3"),
          word: "今天天气很热。|Jīntiān tiānqì hěn rè.",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-01.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_02.mp3"),
          word: "真漂亮!|Zhēn piàoliang!",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-04.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_03.mp3"),
          word: "给我这个瓶子, 好不好?|Gěi wǒ zhège píngzi, hǎo bu hǎo?",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-03.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_04.mp3"),
          word: "给你!|Gěi nǐ!",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-06.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_05.mp3"),
          word: "我的玩具坏了。|Wǒ de wánjù huài le.",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-05.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_06.mp3"),
          word: "给我这个玩具, 好不好？|Gěi wǒ zhège wánjù, hǎo bu hǎo?",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-08.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_07.mp3"),
          word: "给我这些衣服, 好不好?|Gěi wǒ zhèxiē yīfu, hǎo bu hǎo?",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-07.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_08.mp3"),
          word: "真奇怪!|Zhēn qíguài!",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-10.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_09.mp3"),
          word: "他为什么不来玩儿呢?|Tā wèishénme bù lái wánr ne?",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-09.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_10.mp3"),
          word: "他肚子疼。|Tā dùzi téng.",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-12.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_11.mp3"),
          word: "我们去看看他吧。|Wǒmen qù kànkan tā ba.",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-11.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_12.mp3"),
          word: "我要给他一个礼物。|Wǒ yào gěi tā yí ge lǐwù.",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-14.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_13.mp3"),
          word: "一会儿见!|Yíhuìr jiàn!",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-13.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_14.mp3"),
          word: "这是我送给你的礼物。|Zhè shì wǒ sòng gěi nǐ de lǐwù.",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-16.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_15.mp3"),
          word: "谢谢你的礼物!|Xièxie nǐ de lǐwù!",
        },
        {
          img: require("@data/assets/purple/book2/images/img_P2-15.png"),
          sound: require("@data/assets/purple/book2/sounds/KG02_W_16.mp3"),
          word: "让我想想!|Ràng wǒ xiǎngxiang!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book2/images/img_P2-02.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_01.mp3"),
        buttons: [
          { ch2: "Jīntiān tiānqì hěn rè." },
          { ch: "今天天气很热。" },
          { ko: "오늘은 날씨가 매우 더워." },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-01.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_02.mp3"),
        buttons: [
          { ch2: "Zhēn piàoliang!" },
          { ch: "真漂亮!" },
          { ko: "정말 예쁘다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-04.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_03.mp3"),
        buttons: [
          { ch2: "Gěi wǒ zhège píngzi, hǎo bu hǎo?" },
          { ch: "给我这个瓶子, 好不好?" },
          { ko: "이 병 좀 저에게 주시겠어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-03.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_04.mp3"),
        buttons: [{ ch2: "Gěi nǐ!" }, { ch: "给你!" }, { ko: "여기 있어요!" }],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-06.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_05.mp3"),
        buttons: [
          { ch2: "Wǒ de wánjù huài le." },
          { ch: "我的玩具坏了。" },
          { ko: "내 장난감이 망가졌어." },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-05.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_06.mp3"),
        buttons: [
          { ch2: "Gěi wǒ zhège wánjù, hǎo bu hǎo?" },
          { ch: "给我这个玩具, 好不好？" },
          { ko: "이 장난감 좀 주시겠어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-08.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_07.mp3"),
        buttons: [
          { ch2: "Gěi wǒ zhèxiē yīfu, hǎo bu hǎo?" },
          { ch: "给我这些衣服, 好不好?" },
          { ko: "이 옷들 좀 주시겠어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-07.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_08.mp3"),
        buttons: [
          { ch2: "Zhēn qíguài!" },
          { ch: "真奇怪!" },
          { ko: "정말 이상해!" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-10.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_09.mp3"),
        buttons: [
          { ch2: "Tā wèishénme bù lái wánr ne?" },
          { ch: "他为什么不来玩儿呢?" },
          { ko: "그는 왜 놀러 오지 않지?" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-09.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_10.mp3"),
        buttons: [
          { ch2: "Tā dùzi téng." },
          { ch: "他肚子疼。" },
          { ko: "그는 배가 아파." },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-12.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_11.mp3"),
        buttons: [
          { ch2: "Wǒmen qù kànkan tā ba." },
          { ch: "我们去看看他吧。" },
          { ko: "우리 그를 보러 가요." },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-11.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yào gěi tā yí ge lǐwù." },
          { ch: "我要给他一个礼物。" },
          { ko: "나는 그에게 선물을 하나 주려고 해요." },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-14.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_13.mp3"),
        buttons: [
          { ch2: "Yíhuìr jiàn!" },
          { ch: "一会儿见!" },
          { ko: "이따 봐!" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-13.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_14.mp3"),
        buttons: [
          { ch2: "Zhè shì wǒ sòng gěi nǐ de lǐwù." },
          { ch: "这是我送给你的礼物。" },
          { ko: "이것은 내가 너에게 준 선물이야." },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-16.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_15.mp3"),
        buttons: [
          { ch2: "Xièxie nǐ de lǐwù!" },
          { ch: "谢谢你的礼物!" },
          { ko: "선물 고마워요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book2/images/img_P2-15.png"),
        sound: require("@data/assets/purple/book2/sounds/KG02_W_16.mp3"),
        buttons: [
          { ch2: "Ràng wǒ xiǎngxiang!" },
          { ch: "让我想想!" },
          { ko: "어디 보자!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book2/sounds/KG02_W_13.mp3"),
          img: require("@data/assets/purple/book2/images/img_P2-14.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book2/sounds/KG02_W_05.mp3"),
          answer: [
            [require("@data/assets/purple/book2/images/img_P2-06.png"), true],
            [require("@data/assets/purple/book2/images/img_P2-09.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book2/sounds/KG02_W_08.mp3"),
          answer: [
            ["真奇怪!", true],
            ["让我想想!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book2/pages/front.jpg"),
        sound: require("@data/assets/purple/book2/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page04.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page06.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page08.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page10.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page12.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page14.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page16.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page18.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page20.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page22.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page23.jpg"),
        sound: require("@data/assets/purple/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book2/thumbnail/front.jpg"),
      require("@data/assets/purple/book2/thumbnail/page02.jpg"),
      require("@data/assets/purple/book2/thumbnail/page03.jpg"),
      require("@data/assets/purple/book2/thumbnail/page04.jpg"),
      require("@data/assets/purple/book2/thumbnail/page05.jpg"),
      require("@data/assets/purple/book2/thumbnail/page06.jpg"),
      require("@data/assets/purple/book2/thumbnail/page07.jpg"),
      require("@data/assets/purple/book2/thumbnail/page08.jpg"),
      require("@data/assets/purple/book2/thumbnail/page09.jpg"),
      require("@data/assets/purple/book2/thumbnail/page10.jpg"),
      require("@data/assets/purple/book2/thumbnail/page11.jpg"),
      require("@data/assets/purple/book2/thumbnail/page12.jpg"),
      require("@data/assets/purple/book2/thumbnail/page13.jpg"),
      require("@data/assets/purple/book2/thumbnail/page14.jpg"),
      require("@data/assets/purple/book2/thumbnail/page15.jpg"),
      require("@data/assets/purple/book2/thumbnail/page16.jpg"),
      require("@data/assets/purple/book2/thumbnail/page17.jpg"),
      require("@data/assets/purple/book2/thumbnail/page18.jpg"),
      require("@data/assets/purple/book2/thumbnail/page19.jpg"),
      require("@data/assets/purple/book2/thumbnail/page20.jpg"),
      require("@data/assets/purple/book2/thumbnail/page21.jpg"),
      require("@data/assets/purple/book2/thumbnail/page22.jpg"),
      require("@data/assets/purple/book2/thumbnail/page23.jpg"),
      require("@data/assets/purple/book2/thumbnail/page24.jpg"),
      require("@data/assets/purple/book2/thumbnail/page25.jpg"),
      require("@data/assets/purple/book2/thumbnail/page26.jpg"),
      require("@data/assets/purple/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c7-03",
    title: "지도 속 대모험",
    grade: "3권",
    cover: require("@data/assets/purple/book3/images/cover.jpg"),
    background: require("@data/assets/purple/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book3/sounds/page23.mp3"),
      title: "Zhèli shì nǎli?",
      caption: [
        "qǐngwèn zhèli shì nǎli zhèli shì nǎli zhèli shì Zhōngguó",
        "qǐngwèn zhèli shì nǎli zhèli shì nǎli zhèli shì Āijí",
        "qǐngwèn zhèli shì nǎli zhèli shì nǎli zhèli shì Xīlà",
        "zhèli hěn dà zhèli hěn piàoliang",
        "zhèli hěn dà zhèli hěn piàoliang",
      ],
    },
    mov: {
      cn: "742ac9bb5bc5cd77b925c1f67a63892b_03",
      en: "d62841a2980840e6a0dff51c05317048_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book3/images/img_P3-02.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_01.mp3"),
          word: "这是地图。|Zhè shì dìtú.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-01.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_02.mp3"),
          word: "请问, 这里是哪里?|Qǐngwèn, zhèli shì nǎli?",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-03.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_03.mp3"),
          word: "这里是中国。|Zhèli shì Zhōngguó.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-04.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_04.mp3"),
          word: "这里很大。|Zhèli hěn dà.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-06.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_05.mp3"),
          word: "这是龙。|Zhè shì lóng.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-05.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_06.mp3"),
          word: "我在飞。|Wǒ zài fēi.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-08.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_07.mp3"),
          word: "那是长城。|Nà shì Chángchéng.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-07.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_08.mp3"),
          word: "这里是埃及。|Zhèli shì Āijí.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-10.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_09.mp3"),
          word: "我害怕。|Wǒ hàipà.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-09.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_10.mp3"),
          word: "站住!|Zhànzhù!",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-12.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_11.mp3"),
          word: "别过来!|Bié guòlái!",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-11.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_12.mp3"),
          word: "这里是希腊。|Zhèli shì Xīlà.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-14.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_13.mp3"),
          word: "这里很漂亮。|Zhèli hěn piàoliang.",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-13.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_14.mp3"),
          word: "你们来吧!|Nǐmen lái ba!",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-16.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_15.mp3"),
          word: "我们赢了!|Wǒmen yíng le!",
        },
        {
          img: require("@data/assets/purple/book3/images/img_P3-15.png"),
          sound: require("@data/assets/purple/book3/sounds/KG03_W_16.mp3"),
          word: "我回来了。|Wǒ huílái le.",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book3/images/img_P3-02.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_01.mp3"),
        buttons: [
          { ch2: "Zhè shì dìtú." },
          { ch: "这是地图。" },
          { ko: "이것은 지도야." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-01.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_02.mp3"),
        buttons: [
          { ch2: "Qǐngwèn, zhèli shì nǎli?" },
          { ch: "请问, 这里是哪里?" },
          { ko: "실례지만, 여기는 어디입니까?" },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-04.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_03.mp3"),
        buttons: [
          { ch2: "Zhèli shì Zhōngguó." },
          { ch: "这里是中国。" },
          { ko: "여기는 중국입니다." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-03.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_04.mp3"),
        buttons: [
          { ch2: "Zhèli hěn dà." },
          { ch: "这里很大。" },
          { ko: "이곳은 매우 크다." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-06.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_05.mp3"),
        buttons: [
          { ch2: "Zhè shì lóng." },
          { ch: "这是龙。" },
          { ko: "이것은 용이야." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-05.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ zài fēi." },
          { ch: "我在飞。" },
          { ko: "나는 날고 있어." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-08.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_07.mp3"),
        buttons: [
          { ch2: "Nà shì Chángchéng." },
          { ch: "那是长城。" },
          { ko: "저것은 만리장성이야." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-07.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_08.mp3"),
        buttons: [
          { ch2: "Zhèli shì Āijí." },
          { ch: "这里是埃及。" },
          { ko: "여기는 이집트야." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-10.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ hàipà." },
          { ch: "我害怕。" },
          { ko: "무서워요." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-09.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_10.mp3"),
        buttons: [{ ch2: "Zhànzhù!" }, { ch: "站住!" }, { ko: "멈춰!" }],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-12.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_11.mp3"),
        buttons: [
          { ch2: "Bié guòlái!" },
          { ch: "别过来!" },
          { ko: "오지 마!" },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-11.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_12.mp3"),
        buttons: [
          { ch2: "Zhèli shì Xīlà." },
          { ch: "这里是希腊。" },
          { ko: "여기는 그리스야." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-14.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_13.mp3"),
        buttons: [
          { ch2: "Zhèli hěn piàoliang." },
          { ch: "这里很漂亮。" },
          { ko: "여기는 예뻐요." },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-13.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_14.mp3"),
        buttons: [
          { ch2: "Nǐmen lái ba!" },
          { ch: "你们来吧!" },
          { ko: "너희들 와봐!" },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-16.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_15.mp3"),
        buttons: [
          { ch2: "Wǒmen yíng le!" },
          { ch: "我们赢了!" },
          { ko: "우리가 이겼다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book3/images/img_P3-15.png"),
        sound: require("@data/assets/purple/book3/sounds/KG03_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ huílái le." },
          { ch: "我回来了。" },
          { ko: "내가 돌아왔어." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book3/sounds/KG03_W_04.mp3"),
          img: require("@data/assets/purple/book3/images/img_P3-09.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book3/sounds/KG03_W_03.mp3"),
          answer: [
            [require("@data/assets/purple/book3/images/img_P3-04.png"), true],
            [require("@data/assets/purple/book3/images/img_P3-07.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book3/sounds/KG03_W_07.mp3"),
          answer: [
            ["那是长城。", true],
            ["这里是希腊。", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book3/pages/front.jpg"),
        sound: require("@data/assets/purple/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page04.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page06.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page08.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page10.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page12.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page14.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page16.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page18.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page20.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page22.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page23.jpg"),
        sound: require("@data/assets/purple/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book3/thumbnail/front.jpg"),
      require("@data/assets/purple/book3/thumbnail/page02.jpg"),
      require("@data/assets/purple/book3/thumbnail/page03.jpg"),
      require("@data/assets/purple/book3/thumbnail/page04.jpg"),
      require("@data/assets/purple/book3/thumbnail/page05.jpg"),
      require("@data/assets/purple/book3/thumbnail/page06.jpg"),
      require("@data/assets/purple/book3/thumbnail/page07.jpg"),
      require("@data/assets/purple/book3/thumbnail/page08.jpg"),
      require("@data/assets/purple/book3/thumbnail/page09.jpg"),
      require("@data/assets/purple/book3/thumbnail/page10.jpg"),
      require("@data/assets/purple/book3/thumbnail/page11.jpg"),
      require("@data/assets/purple/book3/thumbnail/page12.jpg"),
      require("@data/assets/purple/book3/thumbnail/page13.jpg"),
      require("@data/assets/purple/book3/thumbnail/page14.jpg"),
      require("@data/assets/purple/book3/thumbnail/page15.jpg"),
      require("@data/assets/purple/book3/thumbnail/page16.jpg"),
      require("@data/assets/purple/book3/thumbnail/page17.jpg"),
      require("@data/assets/purple/book3/thumbnail/page18.jpg"),
      require("@data/assets/purple/book3/thumbnail/page19.jpg"),
      require("@data/assets/purple/book3/thumbnail/page20.jpg"),
      require("@data/assets/purple/book3/thumbnail/page21.jpg"),
      require("@data/assets/purple/book3/thumbnail/page22.jpg"),
      require("@data/assets/purple/book3/thumbnail/page23.jpg"),
      require("@data/assets/purple/book3/thumbnail/page24.jpg"),
      require("@data/assets/purple/book3/thumbnail/page25.jpg"),
      require("@data/assets/purple/book3/thumbnail/page26.jpg"),
      require("@data/assets/purple/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c7-04",
    title: "빨간 여우 로로의 거짓말",
    grade: "4권",
    cover: require("@data/assets/purple/book4/images/cover.jpg"),
    background: require("@data/assets/purple/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book4/sounds/page23.mp3"),
      title: "Bāngbang wǒ!",
      caption: [
        "zěnme bàn zěnme bàn wǒ xiě Hànzi xiě de bù hǎo",
        "gēge bāngbang wǒ gēge bāngbang wǒ hǎo de hǎo de",
        "zěnme bàn zěnme bàn wǒ huà huàr huà de bù hǎo",
        "jiějie bāngbang wǒ jiějie bāngbang wǒ hǎo de hǎo de",
      ],
    },
    mov: {
      cn: "93c6d9d670fc251af47b689b253772e2_04",
      en: "c58ead8e4f031da9657ea36cc1c0539c_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book4/images/img_P4-02.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_01.mp3"),
          word: "作业太多了。|Zuòyè tài duō le.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-01.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_02.mp3"),
          word: "我不想做作业。|Wǒ bù xiǎng zuò zuòyè.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-04.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_03.mp3"),
          word: "帮帮我!|Bāngbang wǒ!",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-03.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_04.mp3"),
          word: "好的。|Hǎo de.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-06.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_05.mp3"),
          word: "写完了。|Xiě wán le.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-05.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_06.mp3"),
          word: "你写汉字写得很好!|Nǐ xiě Hànzì xiě de hěn hǎo!",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-08.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_07.mp3"),
          word: "真了不起!|Zhēn liǎobuqǐ!",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-07.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_08.mp3"),
          word: "我画画儿画得不好。|Wǒ huàhuàr huà de bù hǎo.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-10.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_09.mp3"),
          word: "太好了!|Tài hǎo le!",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-09.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_10.mp3"),
          word: "这是你画的吗?|Zhè shì nǐ huà de ma?",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-12.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_11.mp3"),
          word: "她最棒!|Tā zuì bàng!",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-11.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_12.mp3"),
          word: "糟糕!|Zāogāo!",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-14.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_13.mp3"),
          word: "画完了吗?|Huà wán le ma?",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-13.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_14.mp3"),
          word: "画完了。|Huà wán le.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-16.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_15.mp3"),
          word: "我错了。|Wǒ cuò le.",
        },
        {
          img: require("@data/assets/purple/book4/images/img_P4-15.png"),
          sound: require("@data/assets/purple/book4/sounds/KG04_W_16.mp3"),
          word: "没关系!|Méiguānxi!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book4/images/img_P4-02.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_01.mp3"),
        buttons: [
          { ch2: "Zuòyè tài duō le." },
          { ch: "作业太多了。" },
          { ko: "숙제가 너무 많아." },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-01.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_02.mp3"),
        buttons: [
          { ch2: "Wǒ bù xiǎng zuò zuòyè." },
          { ch: "我不想做作业。" },
          { ko: "나는 숙제를 하고 싶지 않아." },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-04.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_03.mp3"),
        buttons: [
          { ch2: "Bāngbang wǒ!" },
          { ch: "帮帮我!" },
          { ko: "도와주세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-03.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_04.mp3"),
        buttons: [{ ch2: "Hǎo de." }, { ch: "好的。" }, { ko: "네." }],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-06.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_05.mp3"),
        buttons: [
          { ch2: "Xiě wán le." },
          { ch: "写完了。" },
          { ko: "다 썼어." },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-05.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_06.mp3"),
        buttons: [
          { ch2: "Nǐ xiě Hànzì xiě de hěn hǎo!" },
          { ch: "你写汉字写得很好!" },
          { ko: "너는 한자를 잘 쓴다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-08.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_07.mp3"),
        buttons: [
          { ch2: "Zhēn liǎobuqǐ!" },
          { ch: "真了不起!" },
          { ko: "정말 대단하다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-07.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_08.mp3"),
        buttons: [
          { ch2: "Wǒ huàhuàr huà de bù hǎo." },
          { ch: "我画画儿画得不好。" },
          { ko: "나는 그림을 잘 그리지 못한다." },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-10.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_09.mp3"),
        buttons: [
          { ch2: "Tài hǎo le!" },
          { ch: "太好了!" },
          { ko: "너무 좋다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-09.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_10.mp3"),
        buttons: [
          { ch2: "Zhè shì nǐ huà de ma?" },
          { ch: "这是你画的吗?" },
          { ko: "이것은 네가 그린 것이니?" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-12.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_11.mp3"),
        buttons: [
          { ch2: "Tā zuì bàng!" },
          { ch: "她最棒!" },
          { ko: "그녀가 최고야!" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-11.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_12.mp3"),
        buttons: [{ ch2: "Zāogāo!" }, { ch: "糟糕!" }, { ko: "아뿔싸!" }],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-14.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_13.mp3"),
        buttons: [
          { ch2: "Huà wán le ma?" },
          { ch: "画完了吗?" },
          { ko: "다 그렸나요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-13.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_14.mp3"),
        buttons: [
          { ch2: "Huà wán le." },
          { ch: "画完了。" },
          { ko: "그림을 다 그렸어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-16.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ cuò le." },
          { ch: "我错了。" },
          { ko: "내가 잘못했어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book4/images/img_P4-15.png"),
        sound: require("@data/assets/purple/book4/sounds/KG04_W_16.mp3"),
        buttons: [{ ch2: "Méiguānxi!" }, { ch: "没关系!" }, { ko: "괜찮아!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book4/sounds/KG04_W_03.mp3"),
          img: require("@data/assets/purple/book4/images/img_P4-06.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book4/sounds/KG04_W_07.mp3"),
          answer: [
            [require("@data/assets/purple/book4/images/img_P4-08.png"), true],
            [require("@data/assets/purple/book4/images/img_P4-11.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book4/sounds/KG04_W_14.mp3"),
          answer: [
            ["太好了!", false],
            ["画完了。", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book4/pages/front.jpg"),
        sound: require("@data/assets/purple/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page04.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page06.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page08.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page10.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page12.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page14.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page16.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page18.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page20.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page22.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page23.jpg"),
        sound: require("@data/assets/purple/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book4/thumbnail/front.jpg"),
      require("@data/assets/purple/book4/thumbnail/page02.jpg"),
      require("@data/assets/purple/book4/thumbnail/page03.jpg"),
      require("@data/assets/purple/book4/thumbnail/page04.jpg"),
      require("@data/assets/purple/book4/thumbnail/page05.jpg"),
      require("@data/assets/purple/book4/thumbnail/page06.jpg"),
      require("@data/assets/purple/book4/thumbnail/page07.jpg"),
      require("@data/assets/purple/book4/thumbnail/page08.jpg"),
      require("@data/assets/purple/book4/thumbnail/page09.jpg"),
      require("@data/assets/purple/book4/thumbnail/page10.jpg"),
      require("@data/assets/purple/book4/thumbnail/page11.jpg"),
      require("@data/assets/purple/book4/thumbnail/page12.jpg"),
      require("@data/assets/purple/book4/thumbnail/page13.jpg"),
      require("@data/assets/purple/book4/thumbnail/page14.jpg"),
      require("@data/assets/purple/book4/thumbnail/page15.jpg"),
      require("@data/assets/purple/book4/thumbnail/page16.jpg"),
      require("@data/assets/purple/book4/thumbnail/page17.jpg"),
      require("@data/assets/purple/book4/thumbnail/page18.jpg"),
      require("@data/assets/purple/book4/thumbnail/page19.jpg"),
      require("@data/assets/purple/book4/thumbnail/page20.jpg"),
      require("@data/assets/purple/book4/thumbnail/page21.jpg"),
      require("@data/assets/purple/book4/thumbnail/page22.jpg"),
      require("@data/assets/purple/book4/thumbnail/page23.jpg"),
      require("@data/assets/purple/book4/thumbnail/page24.jpg"),
      require("@data/assets/purple/book4/thumbnail/page25.jpg"),
      require("@data/assets/purple/book4/thumbnail/page26.jpg"),
      require("@data/assets/purple/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c7-05",
    title: "쿠키 한 개의 행복",
    grade: "5권",
    cover: require("@data/assets/purple/book5/images/cover.jpg"),
    background: require("@data/assets/purple/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book5/sounds/page23.mp3"),
      title: "Nǐ zěnme le?",
      caption: [
        "nǐ zěnme le nǐ zěnme le wǒ hěn è wǒ hěn è",
        "zhè shì bǐnggān gěi nǐ gěi nǐ nǐ zhěn hǎo xièxie xièxie",
        "nǐ zěnme le nǐ zěnme le wǒ gǎnmào le wǒ gǎnmào le",
        "zhè shì shǒujuàn nǐ cā yi cā nǐ zhēn hǎo xièxie xièxie",
      ],
    },
    mov: {
      cn: "2e52ec24985d58d1e70c74f939445459_05",
      en: "c6a3b089c4fc6f5bf846654e39aad139_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book5/images/img_P5-02.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_01.mp3"),
          word: "喂, 你好!|Wéi, nǐ hǎo!",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-01.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_02.mp3"),
          word: "你怎么了?|Nǐ zěnme le?",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-04.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_03.mp3"),
          word: "我很饿。|Wǒ hěn è.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-03.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_04.mp3"),
          word: "你有手绢吗?|Nǐ yǒu shǒujuàn ma?",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-06.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_05.mp3"),
          word: "没有。|Méiyǒu.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-05.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_06.mp3"),
          word: "我感冒了。|Wǒ gǎnmào le.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-08.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_07.mp3"),
          word: "你擦一擦。|Nǐ cā yi cā.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-07.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_08.mp3"),
          word: "你喜欢花儿吗?|Nǐ xǐhuan huār ma?",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-10.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_09.mp3"),
          word: "喜欢。|Xǐhuan.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-09.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_10.mp3"),
          word: "哇! 好香!|Wā! Hǎo xiāng!",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-12.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_11.mp3"),
          word: "你喜欢水果吗?|Nǐ xǐhuan shuǐguǒ ma?",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-11.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_12.mp3"),
          word: "水果都坏了。|Shuǐguǒ dōu huài le.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-14.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_13.mp3"),
          word: "给你这些水果。|Gěi nǐ zhèxiē shuǐguǒ.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-13.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_14.mp3"),
          word: "你真好!|Nǐ zhēn hǎo!",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-16.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_15.mp3"),
          word: "我很高兴。|Wǒ hěn gāoxìng.",
        },
        {
          img: require("@data/assets/purple/book5/images/img_P5-15.png"),
          sound: require("@data/assets/purple/book5/sounds/KG05_W_16.mp3"),
          word: "哇! 好甜!|Wā! Hǎo tián!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book5/images/img_P5-02.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_01.mp3"),
        buttons: [
          { ch2: "Wéi, nǐ hǎo!" },
          { ch: "喂, 你好!" },
          { ko: "여보세요, 안녕하세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-01.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_02.mp3"),
        buttons: [
          { ch2: "Nǐ zěnme le?" },
          { ch: "你怎么了?" },
          { ko: "너 왜 그래?" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-04.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_03.mp3"),
        buttons: [
          { ch2: "Wǒ hěn è." },
          { ch: "我很饿。" },
          { ko: "나 배고파." },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-03.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_04.mp3"),
        buttons: [
          { ch2: "Nǐ yǒu shǒujuàn ma?" },
          { ch: "你有手绢吗?" },
          { ko: "손수건 있어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-06.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_05.mp3"),
        buttons: [{ ch2: "Méiyǒu." }, { ch: "没有。" }, { ko: "아니요." }],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-05.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ gǎnmào le." },
          { ch: "我感冒了。" },
          { ko: "저 감기에 걸렸어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-08.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ cā yi cā." },
          { ch: "你擦一擦。" },
          { ko: "너 좀 닦아라." },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-07.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ xǐhuan huār ma?" },
          { ch: "你喜欢花儿吗?" },
          { ko: "당신은 꽃을 좋아해요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-10.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_09.mp3"),
        buttons: [{ ch2: "Xǐhuan." }, { ch: "喜欢。" }, { ko: "좋아해요." }],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-09.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_10.mp3"),
        buttons: [
          { ch2: "Wā! Hǎo xiāng!" },
          { ch: "哇! 好香!" },
          { ko: "우와! 향기롭다!" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-12.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_11.mp3"),
        buttons: [
          { ch2: "Nǐ xǐhuan shuǐguǒ ma?" },
          { ch: "你喜欢水果吗?" },
          { ko: "너는 과일을 좋아하니?" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-11.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_12.mp3"),
        buttons: [
          { ch2: "Shuǐguǒ dōu huài le." },
          { ch: "水果都坏了。" },
          { ko: "과일이 다 상했어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-14.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_13.mp3"),
        buttons: [
          { ch2: "Gěi nǐ zhèxiē shuǐguǒ." },
          { ch: "给你这些水果。" },
          { ko: "이 과일을 좀 드릴게요." },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-13.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_14.mp3"),
        buttons: [
          { ch2: "Nǐ zhēn hǎo!" },
          { ch: "你真好!" },
          { ko: "너는 정말 친절하구나!" },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-16.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ hěn gāoxìng." },
          { ch: "我很高兴。" },
          { ko: "나는 기쁘다." },
        ],
      },
      {
        img: require("@data/assets/purple/book5/images/img_P5-15.png"),
        sound: require("@data/assets/purple/book5/sounds/KG05_W_16.mp3"),
        buttons: [
          { ch2: "Wā! Hǎo tián!" },
          { ch: "哇! 好甜!" },
          { ko: "와! 달다!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book5/sounds/KG05_W_02.mp3"),
          img: require("@data/assets/purple/book5/images/img_P5-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book5/sounds/KG05_W_01.mp3"),
          answer: [
            [require("@data/assets/purple/book5/images/img_P5-02.png"), true],
            [require("@data/assets/purple/book5/images/img_P5-06.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book5/sounds/KG05_W_15.mp3"),
          answer: [
            ["我很饿。", false],
            ["我很高兴。", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book5/pages/front.jpg"),
        sound: require("@data/assets/purple/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page04.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page06.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page08.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page10.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page12.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page14.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page16.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page18.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page20.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page22.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page23.jpg"),
        sound: require("@data/assets/purple/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book5/thumbnail/front.jpg"),
      require("@data/assets/purple/book5/thumbnail/page02.jpg"),
      require("@data/assets/purple/book5/thumbnail/page03.jpg"),
      require("@data/assets/purple/book5/thumbnail/page04.jpg"),
      require("@data/assets/purple/book5/thumbnail/page05.jpg"),
      require("@data/assets/purple/book5/thumbnail/page06.jpg"),
      require("@data/assets/purple/book5/thumbnail/page07.jpg"),
      require("@data/assets/purple/book5/thumbnail/page08.jpg"),
      require("@data/assets/purple/book5/thumbnail/page09.jpg"),
      require("@data/assets/purple/book5/thumbnail/page10.jpg"),
      require("@data/assets/purple/book5/thumbnail/page11.jpg"),
      require("@data/assets/purple/book5/thumbnail/page12.jpg"),
      require("@data/assets/purple/book5/thumbnail/page13.jpg"),
      require("@data/assets/purple/book5/thumbnail/page14.jpg"),
      require("@data/assets/purple/book5/thumbnail/page15.jpg"),
      require("@data/assets/purple/book5/thumbnail/page16.jpg"),
      require("@data/assets/purple/book5/thumbnail/page17.jpg"),
      require("@data/assets/purple/book5/thumbnail/page18.jpg"),
      require("@data/assets/purple/book5/thumbnail/page19.jpg"),
      require("@data/assets/purple/book5/thumbnail/page20.jpg"),
      require("@data/assets/purple/book5/thumbnail/page21.jpg"),
      require("@data/assets/purple/book5/thumbnail/page22.jpg"),
      require("@data/assets/purple/book5/thumbnail/page23.jpg"),
      require("@data/assets/purple/book5/thumbnail/page24.jpg"),
      require("@data/assets/purple/book5/thumbnail/page25.jpg"),
      require("@data/assets/purple/book5/thumbnail/page26.jpg"),
      require("@data/assets/purple/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c7-06",
    title: "부러워, 부러워!",
    grade: "6권",
    cover: require("@data/assets/purple/book6/images/cover.jpg"),
    background: require("@data/assets/purple/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book6/sounds/page23.mp3"),
      title: "Wǒ de wěiba zěnmeyàng?",
      caption: [
        "kǒngquè hěn piàoliang xiànmù xiànmù wǒ xiànmù tā",
        "wǒ de wěiba zěnmeyàng bù zěnmeyàng bù zěnmeyàng",
        "kǒnglóng zhēn dà xiànmù xiànmù wǒ xiànmù tā",
        "wǒ de xiézi zěnmeyàng bù zěnmeyàng bù zěnmeyàng",
      ],
    },
    mov: {
      cn: "40d248f51d8ce7eeb73d5b6b4d26ef67_06",
      en: "002c7573ea0c7678bfa310686afc43a8_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book6/images/img_P6-02.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_01.mp3"),
          word: "狮子很帅。|Shīzi hěn shuài.",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-01.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_02.mp3"),
          word: "我羡慕他。|Wǒ xiànmù tā.",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-04.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_03.mp3"),
          word: "孔雀很漂亮。|Kǒngquè hěn piàoliang.",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-03.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_04.mp3"),
          word: "我不羡慕他。|Wǒ bú xiànmù tā.",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-06.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_05.mp3"),
          word: "我的尾巴怎么样?|Wǒ de wěiba zěnmeyàng?",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-05.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_06.mp3"),
          word: "不怎么样。|Bù zěnmeyàng.",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-08.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_07.mp3"),
          word: "恐龙真大!|Kǒnglóng zhēn dà!",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-07.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_08.mp3"),
          word: "老鼠很小。|Lǎoshǔ hěn xiǎo.",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-10.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_09.mp3"),
          word: "我的鞋子怎么样?|Wǒ de xiézi zěnmeyàng?",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-09.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_10.mp3"),
          word: "哼, 你嫉妒我吧?|Hēng, nǐ jídù wǒ ba?",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-12.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_11.mp3"),
          word: "你们出来吧!|Nǐmen chūlái ba!",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-11.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_12.mp3"),
          word: "我的样子怎么样?|Wǒ de yàngzi zěnmeyàng?",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-14.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_13.mp3"),
          word: "快进去吧!|Kuài jìnqù ba!",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-13.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_14.mp3"),
          word: "我不能进去!|Wǒ bù néng jìnqù!",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-16.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_15.mp3"),
          word: "救命啊!|Jiù mìng a!",
        },
        {
          img: require("@data/assets/purple/book6/images/img_P6-15.png"),
          sound: require("@data/assets/purple/book6/sounds/KG06_W_16.mp3"),
          word: "太感谢你了!|Tài gǎnxiè nǐ le!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book6/images/img_P6-02.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_01.mp3"),
        buttons: [
          { ch2: "Shīzi hěn shuài." },
          { ch: "狮子很帅。" },
          { ko: "사자는 멋있어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-01.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_02.mp3"),
        buttons: [
          { ch2: "Wǒ xiànmù tā." },
          { ch: "我羡慕他。" },
          { ko: "나는 그가 부러워." },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-04.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_03.mp3"),
        buttons: [
          { ch2: "Kǒngquè hěn piàoliang." },
          { ch: "孔雀很漂亮。" },
          { ko: "공작새가 예쁘다." },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-03.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_04.mp3"),
        buttons: [
          { ch2: "Wǒ bú xiànmù tā." },
          { ch: "我不羡慕他。" },
          { ko: "나는 그가 부럽지 않아." },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-06.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_05.mp3"),
        buttons: [
          { ch2: "Wǒ de wěiba zěnmeyàng?" },
          { ch: "我的尾巴怎么样?" },
          { ko: "내 꼬리는 어때?" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-05.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_06.mp3"),
        buttons: [
          { ch2: "Bù zěnmeyàng." },
          { ch: "不怎么样。" },
          { ko: "별로야." },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-08.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_07.mp3"),
        buttons: [
          { ch2: "Kǒnglóng zhēn dà!" },
          { ch: "恐龙真大!" },
          { ko: "공룡은 정말 커!" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-07.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_08.mp3"),
        buttons: [
          { ch2: "Lǎoshǔ hěn xiǎo." },
          { ch: "老鼠很小。" },
          { ko: "쥐는 작아." },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-10.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ de xiézi zěnmeyàng?" },
          { ch: "我的鞋子怎么样?" },
          { ko: "내 신발 어때?" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-09.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_10.mp3"),
        buttons: [
          { ch2: "Hēng, nǐ jídù wǒ ba?" },
          { ch: "哼, 你嫉妒我吧?" },
          { ko: "흥, 너 나 질투하지?" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-12.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_11.mp3"),
        buttons: [
          { ch2: "Nǐmen chūlái ba!" },
          { ch: "你们出来吧!" },
          { ko: "너희들 나와라!" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-11.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ de yàngzi zěnmeyàng?" },
          { ch: "我的样子怎么样?" },
          { ko: "내 모습은 어때?" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-14.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_13.mp3"),
        buttons: [
          { ch2: "Kuài jìnqù ba!" },
          { ch: "快进去吧!" },
          { ko: "어서 들어가!" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-13.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ bù néng jìnqù!" },
          { ch: "我不能进去!" },
          { ko: "나는 들어갈 수 없어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-16.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_15.mp3"),
        buttons: [
          { ch2: "Jiù mìng a!" },
          { ch: "救命啊!" },
          { ko: "살려주세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book6/images/img_P6-15.png"),
        sound: require("@data/assets/purple/book6/sounds/KG06_W_16.mp3"),
        buttons: [
          { ch2: "Tài gǎnxiè nǐ le!" },
          { ch: "太感谢你了!" },
          { ko: "정말 감사합니다!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book6/sounds/KG06_W_01.mp3"),
          img: require("@data/assets/purple/book6/images/img_P6-07.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book6/sounds/KG06_W_07.mp3"),
          answer: [
            [require("@data/assets/purple/book6/images/img_P6-04.png"), false],
            [require("@data/assets/purple/book6/images/img_P6-08.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book6/sounds/KG06_W_13.mp3"),
          answer: [
            ["救命啊!", false],
            ["快进去吧!", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book6/pages/front.jpg"),
        sound: require("@data/assets/purple/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page04.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page06.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page08.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page10.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page12.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page14.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page16.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page18.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page20.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page22.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page23.jpg"),
        sound: require("@data/assets/purple/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book6/thumbnail/front.jpg"),
      require("@data/assets/purple/book6/thumbnail/page02.jpg"),
      require("@data/assets/purple/book6/thumbnail/page03.jpg"),
      require("@data/assets/purple/book6/thumbnail/page04.jpg"),
      require("@data/assets/purple/book6/thumbnail/page05.jpg"),
      require("@data/assets/purple/book6/thumbnail/page06.jpg"),
      require("@data/assets/purple/book6/thumbnail/page07.jpg"),
      require("@data/assets/purple/book6/thumbnail/page08.jpg"),
      require("@data/assets/purple/book6/thumbnail/page09.jpg"),
      require("@data/assets/purple/book6/thumbnail/page10.jpg"),
      require("@data/assets/purple/book6/thumbnail/page11.jpg"),
      require("@data/assets/purple/book6/thumbnail/page12.jpg"),
      require("@data/assets/purple/book6/thumbnail/page13.jpg"),
      require("@data/assets/purple/book6/thumbnail/page14.jpg"),
      require("@data/assets/purple/book6/thumbnail/page15.jpg"),
      require("@data/assets/purple/book6/thumbnail/page16.jpg"),
      require("@data/assets/purple/book6/thumbnail/page17.jpg"),
      require("@data/assets/purple/book6/thumbnail/page18.jpg"),
      require("@data/assets/purple/book6/thumbnail/page19.jpg"),
      require("@data/assets/purple/book6/thumbnail/page20.jpg"),
      require("@data/assets/purple/book6/thumbnail/page21.jpg"),
      require("@data/assets/purple/book6/thumbnail/page22.jpg"),
      require("@data/assets/purple/book6/thumbnail/page23.jpg"),
      require("@data/assets/purple/book6/thumbnail/page24.jpg"),
      require("@data/assets/purple/book6/thumbnail/page25.jpg"),
      require("@data/assets/purple/book6/thumbnail/page26.jpg"),
      require("@data/assets/purple/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c7-07",
    title: "부끄럼쟁이 당나귀",
    grade: "7권",
    cover: require("@data/assets/purple/book7/images/cover.jpg"),
    background: require("@data/assets/purple/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book7/sounds/page23.mp3"),
      title: "Shuǐguǒ yígòng yǒu jǐ ge?",
      caption: [
        "píngguǒ yígòng yǒu jǐ ge yī èr yígòng yǒu liǎng ge",
        "xiāngjiāo yígòng yǒu jǐ ge yī èr sān yígòng yǒu sān ge",
        "níngméng yígòng yǒu jǐ ge yī èr sān sì yígòng yǒu sì ge",
        "shuǐguǒ yígòng yǒu jǐ ge yígòng yǒu jiǔ ge wā hěn duō",
      ],
    },
    mov: {
      cn: "9fb4ef6d102eef9cfe30460b6c8a4c19_07",
      en: "1e32fff19fdf02b112b1d6cc9056b46d_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book7/images/img_P7-02.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_01.mp3"),
          word: "太紧张了。|Tài jǐnzhāng le.",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-01.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_02.mp3"),
          word: "水果一共有几个?|Shuǐguǒ yígòng yǒu jǐ ge?",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-04.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_03.mp3"),
          word: "一共有七个。|Yígòng yǒu qī ge.",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-03.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_04.mp3"),
          word: "铅笔一共有几个?|Qiānbǐ yígòng yǒu jǐ ge?",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-06.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_05.mp3"),
          word: "一共有六个。|Yígòng yǒu liù ge.",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-05.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_06.mp3"),
          word: "很丢脸。|Hěn diūliǎn.",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-08.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_07.mp3"),
          word: "我们一起谈谈吧。|Wǒmen yìqǐ tántan ba.",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-07.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_08.mp3"),
          word: "你怎么想?|Nǐ zěnme xiǎng?",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-10.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_09.mp3"),
          word: "我想……|Wǒ xiǎng……",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-09.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_10.mp3"),
          word: "别担心!|Bié dānxīn!",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-12.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_11.mp3"),
          word: "你也紧张吗?|Nǐ yě jǐnzhāng ma?",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-11.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_12.mp3"),
          word: "我也很紧张。|Wǒ yě hěn jǐnzhāng.",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-14.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_13.mp3"),
          word: "很好!|Hěn hǎo!",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-13.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_14.mp3"),
          word: "别紧张!|Bié jǐnzhāng!",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-16.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_15.mp3"),
          word: "我做到了!|Wǒ zuò dào le!",
        },
        {
          img: require("@data/assets/purple/book7/images/img_P7-15.png"),
          sound: require("@data/assets/purple/book7/sounds/KG07_W_16.mp3"),
          word: "真棒!|Zhēn bàng!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book7/images/img_P7-02.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_01.mp3"),
        buttons: [
          { ch2: "Tài jǐnzhāng le." },
          { ch: "太紧张了。" },
          { ko: "너무 떨려요." },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-01.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_02.mp3"),
        buttons: [
          { ch2: "Shuǐguǒ yígòng yǒu jǐ ge?" },
          { ch: "水果一共有几个?" },
          { ko: "과일은 모두 몇 개입니까?" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-04.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_03.mp3"),
        buttons: [
          { ch2: "Yígòng yǒu qī ge." },
          { ch: "一共有七个。" },
          { ko: "모두 일곱 개이다." },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-03.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_04.mp3"),
        buttons: [
          { ch2: "Qiānbǐ yígòng yǒu jǐ ge?" },
          { ch: "铅笔一共有几个?" },
          { ko: "연필은 모두 몇 개입니까?" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-06.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_05.mp3"),
        buttons: [
          { ch2: "Yígòng yǒu liù ge." },
          { ch: "一共有六个。" },
          { ko: "모두 여섯 개이다." },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-05.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_06.mp3"),
        buttons: [
          { ch2: "Hěn diūliǎn." },
          { ch: "很丢脸。" },
          { ko: "창피해." },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-08.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_07.mp3"),
        buttons: [
          { ch2: "Wǒmen yìqǐ tántan ba." },
          { ch: "我们一起谈谈吧。" },
          { ko: "우리 같이 이야기해요." },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-07.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ zěnme xiǎng?" },
          { ch: "你怎么想?" },
          { ko: "어떻게 생각하세요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-10.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ xiǎng……" },
          { ch: "我想……" },
          { ko: "내 생각에는~" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-09.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_10.mp3"),
        buttons: [
          { ch2: "Bié dānxīn!" },
          { ch: "别担心!" },
          { ko: "걱정하지 마!" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-12.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_11.mp3"),
        buttons: [
          { ch2: "Nǐ yě jǐnzhāng ma?" },
          { ch: "你也紧张吗?" },
          { ko: "너도 긴장했어?" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-11.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ yě hěn jǐnzhāng." },
          { ch: "我也很紧张。" },
          { ko: "나도 긴장돼." },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-14.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_13.mp3"),
        buttons: [{ ch2: "Hěn hǎo!" }, { ch: "很好!" }, { ko: "좋아!" }],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-13.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_14.mp3"),
        buttons: [
          { ch2: "Bié jǐnzhāng!" },
          { ch: "别紧张!" },
          { ko: "긴장하지 마세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-16.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ zuò dào le!" },
          { ch: "我做到了!" },
          { ko: "내가 해냈어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book7/images/img_P7-15.png"),
        sound: require("@data/assets/purple/book7/sounds/KG07_W_16.mp3"),
        buttons: [{ ch2: "Zhēn bàng!" }, { ch: "真棒!" }, { ko: "대단해!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book7/sounds/KG07_W_10.mp3"),
          img: require("@data/assets/purple/book7/images/img_P7-15.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book7/sounds/KG07_W_01.mp3"),
          answer: [
            [require("@data/assets/purple/book7/images/img_P7-08.png"), false],
            [require("@data/assets/purple/book7/images/img_P7-02.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book7/sounds/KG07_W_10.mp3"),
          answer: [
            ["别担心!", true],
            ["别紧张!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book7/pages/front.jpg"),
        sound: require("@data/assets/purple/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page04.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page06.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page08.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page10.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page12.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page14.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page16.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page18.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page20.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page22.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page23.jpg"),
        sound: require("@data/assets/purple/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book7/thumbnail/front.jpg"),
      require("@data/assets/purple/book7/thumbnail/page02.jpg"),
      require("@data/assets/purple/book7/thumbnail/page03.jpg"),
      require("@data/assets/purple/book7/thumbnail/page04.jpg"),
      require("@data/assets/purple/book7/thumbnail/page05.jpg"),
      require("@data/assets/purple/book7/thumbnail/page06.jpg"),
      require("@data/assets/purple/book7/thumbnail/page07.jpg"),
      require("@data/assets/purple/book7/thumbnail/page08.jpg"),
      require("@data/assets/purple/book7/thumbnail/page09.jpg"),
      require("@data/assets/purple/book7/thumbnail/page10.jpg"),
      require("@data/assets/purple/book7/thumbnail/page11.jpg"),
      require("@data/assets/purple/book7/thumbnail/page12.jpg"),
      require("@data/assets/purple/book7/thumbnail/page13.jpg"),
      require("@data/assets/purple/book7/thumbnail/page14.jpg"),
      require("@data/assets/purple/book7/thumbnail/page15.jpg"),
      require("@data/assets/purple/book7/thumbnail/page16.jpg"),
      require("@data/assets/purple/book7/thumbnail/page17.jpg"),
      require("@data/assets/purple/book7/thumbnail/page18.jpg"),
      require("@data/assets/purple/book7/thumbnail/page19.jpg"),
      require("@data/assets/purple/book7/thumbnail/page20.jpg"),
      require("@data/assets/purple/book7/thumbnail/page21.jpg"),
      require("@data/assets/purple/book7/thumbnail/page22.jpg"),
      require("@data/assets/purple/book7/thumbnail/page23.jpg"),
      require("@data/assets/purple/book7/thumbnail/page24.jpg"),
      require("@data/assets/purple/book7/thumbnail/page25.jpg"),
      require("@data/assets/purple/book7/thumbnail/page26.jpg"),
      require("@data/assets/purple/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c7-08",
    title: "챔피언은 누구?",
    grade: "8권",
    cover: require("@data/assets/purple/book8/images/cover.jpg"),
    background: require("@data/assets/purple/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book8/sounds/page23.mp3"),
      title: "Yùndònghuì shénme shíhou kāi?",
      caption: [
        "yùndònghuì shénme shíhou kāi bā yuè jiǔ hào bā yuè jiǔ hào",
        "bǐsài shénme shíhou kāishǐ xiàwǔ yī diǎn xiàwǔ yī diǎn",
        "jiāyóu jiāyóu āiyō wǒ shū le wǒ shū le",
        "jiāyóu jiāyóu wā wǒ yíng le wǒ yíng le",
      ],
    },
    mov: {
      cn: "3ebe01b0be2b9232fd0662386e38abe7_08",
      en: "abbb782e26f6a5101c68afbcd846428b_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book8/images/img_P8-02.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_01.mp3"),
          word: "运动会什么时候开?|Yùndònghuì shénme shíhou kāi?",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-01.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_02.mp3"),
          word: "八月九号。|Bā yuè jiǔ hào.",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-04.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_03.mp3"),
          word: "奖杯是我的!|Jiǎngbēi shì wǒ de!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-03.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_04.mp3"),
          word: "老虎更强。|Lǎohǔ gèng qiáng.",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-06.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_05.mp3"),
          word: "我输了。|Wǒ shū le.",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-05.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_06.mp3"),
          word: "加油!|Jiāyóu!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-08.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_07.mp3"),
          word: "我赢了!|Wǒ yíng le!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-07.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_08.mp3"),
          word: "比赛什么时候开始?|Bǐsài shénme shíhou kāishǐ?",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-10.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_09.mp3"),
          word: "下午一点。|Xiàwǔ yī diǎn.",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-09.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_10.mp3"),
          word: "狮子更快。|Shīzi gèng kuài.",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-12.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_11.mp3"),
          word: "预备!|Yùbèi!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-11.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_12.mp3"),
          word: "不行!|Bù xíng!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-14.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_13.mp3"),
          word: "哎哟!|Āiyō!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-13.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_14.mp3"),
          word: "怎么办?|Zěnme bàn?",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-16.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_15.mp3"),
          word: "我帮你!|Wǒ bāng nǐ!",
        },
        {
          img: require("@data/assets/purple/book8/images/img_P8-15.png"),
          sound: require("@data/assets/purple/book8/sounds/KG08_W_16.mp3"),
          word: "你是冠军!|Nǐ shì guànjūn!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book8/images/img_P8-02.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_01.mp3"),
        buttons: [
          { ch2: "Yùndònghuì shénme shíhou kāi?" },
          { ch: "运动会什么时候开?" },
          { ko: "운동회는 언제 합니까?" },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-01.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_02.mp3"),
        buttons: [
          { ch2: "Bā yuè jiǔ hào." },
          { ch: "八月九号。" },
          { ko: "8월 9일." },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-04.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_03.mp3"),
        buttons: [
          { ch2: "Jiǎngbēi shì wǒ de!" },
          { ch: "奖杯是我的!" },
          { ko: "트로피는 내 거야!" },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-03.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_04.mp3"),
        buttons: [
          { ch2: "Lǎohǔ gèng qiáng." },
          { ch: "老虎更强。" },
          { ko: "호랑이가 더 강해." },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-06.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_05.mp3"),
        buttons: [
          { ch2: "Wǒ shū le." },
          { ch: "我输了。" },
          { ko: "내가 졌어." },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-05.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_06.mp3"),
        buttons: [{ ch2: "Jiāyóu!" }, { ch: "加油!" }, { ko: "화이팅!" }],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-08.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_07.mp3"),
        buttons: [
          { ch2: "Wǒ yíng le!" },
          { ch: "我赢了!" },
          { ko: "내가 이겼어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-07.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_08.mp3"),
        buttons: [
          { ch2: "Bǐsài shénme shíhou kāishǐ?" },
          { ch: "比赛什么时候开始?" },
          { ko: "경기는 언제 시작해?" },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-10.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_09.mp3"),
        buttons: [
          { ch2: "Xiàwǔ yī diǎn." },
          { ch: "下午一点。" },
          { ko: "오후 1시." },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-09.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_10.mp3"),
        buttons: [
          { ch2: "Shīzi gèng kuài." },
          { ch: "狮子更快。" },
          { ko: "사자가 더 빨라." },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-12.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_11.mp3"),
        buttons: [{ ch2: "Yùbèi!" }, { ch: "预备!" }, { ko: "준비!" }],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-11.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_12.mp3"),
        buttons: [{ ch2: "Bù xíng!" }, { ch: "不行!" }, { ko: "안 돼!" }],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-14.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_13.mp3"),
        buttons: [{ ch2: "Āiyō!" }, { ch: "哎哟!" }, { ko: "아이고!" }],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-13.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_14.mp3"),
        buttons: [
          { ch2: "Zěnme bàn?" },
          { ch: "怎么办?" },
          { ko: "어떡하지?" },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-16.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ bāng nǐ!" },
          { ch: "我帮你!" },
          { ko: "내가 도와줄게!" },
        ],
      },
      {
        img: require("@data/assets/purple/book8/images/img_P8-15.png"),
        sound: require("@data/assets/purple/book8/sounds/KG08_W_16.mp3"),
        buttons: [
          { ch2: "Nǐ shì guànjūn!" },
          { ch: "你是冠军!" },
          { ko: "네가 챔피언이야!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book8/sounds/KG08_W_02.mp3"),
          img: require("@data/assets/purple/book8/images/img_P8-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book8/sounds/KG08_W_06.mp3"),
          answer: [
            [require("@data/assets/purple/book8/images/img_P8-06.png"), false],
            [require("@data/assets/purple/book8/images/img_P8-05.png"), true],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book8/sounds/KG08_W_15.mp3"),
          answer: [
            ["怎么办?", false],
            ["我帮你!", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book8/pages/front.jpg"),
        sound: require("@data/assets/purple/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page04.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page06.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page08.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page10.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page12.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page14.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page16.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page18.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page20.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page22.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page23.jpg"),
        sound: require("@data/assets/purple/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book8/thumbnail/front.jpg"),
      require("@data/assets/purple/book8/thumbnail/page02.jpg"),
      require("@data/assets/purple/book8/thumbnail/page03.jpg"),
      require("@data/assets/purple/book8/thumbnail/page04.jpg"),
      require("@data/assets/purple/book8/thumbnail/page05.jpg"),
      require("@data/assets/purple/book8/thumbnail/page06.jpg"),
      require("@data/assets/purple/book8/thumbnail/page07.jpg"),
      require("@data/assets/purple/book8/thumbnail/page08.jpg"),
      require("@data/assets/purple/book8/thumbnail/page09.jpg"),
      require("@data/assets/purple/book8/thumbnail/page10.jpg"),
      require("@data/assets/purple/book8/thumbnail/page11.jpg"),
      require("@data/assets/purple/book8/thumbnail/page12.jpg"),
      require("@data/assets/purple/book8/thumbnail/page13.jpg"),
      require("@data/assets/purple/book8/thumbnail/page14.jpg"),
      require("@data/assets/purple/book8/thumbnail/page15.jpg"),
      require("@data/assets/purple/book8/thumbnail/page16.jpg"),
      require("@data/assets/purple/book8/thumbnail/page17.jpg"),
      require("@data/assets/purple/book8/thumbnail/page18.jpg"),
      require("@data/assets/purple/book8/thumbnail/page19.jpg"),
      require("@data/assets/purple/book8/thumbnail/page20.jpg"),
      require("@data/assets/purple/book8/thumbnail/page21.jpg"),
      require("@data/assets/purple/book8/thumbnail/page22.jpg"),
      require("@data/assets/purple/book8/thumbnail/page23.jpg"),
      require("@data/assets/purple/book8/thumbnail/page24.jpg"),
      require("@data/assets/purple/book8/thumbnail/page25.jpg"),
      require("@data/assets/purple/book8/thumbnail/page26.jpg"),
      require("@data/assets/purple/book8/thumbnail/page27.jpg"),
    ],
  },
  //9
  {
    key: "c7-09",
    title: "빨리 가야지",
    grade: "9권",
    cover: require("@data/assets/purple/book9/images/cover.jpg"),
    background: require("@data/assets/purple/book9/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book9/sounds/page23.mp3"),
      title: "Nǐ pái duì ba!",
      caption: [
        "tā chā duì le nǐ pái duì ba nǐ pái duì ba zhīdào le zhīdào le",
        "tài wēixiǎn le nǐ jì ānquándài ba nǐ jì ānquándài ba",
        "zhīdào le tài màn le kuài diǎnr kuài diǎnr bié zháojí",
        "yīnggāi zhùyì ānquán yīnggāi zhùyì ānquán",
        "zhīdào le zhīdào le",
      ],
    },
    mov: {
      cn: "a0eecced9c1c4f72f3c97932851659c0_09",
      en: "dd19174b1b630d5ccc6359cd595b80d1_09",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book9/images/img_P9-02.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_01.mp3"),
          word: "他最棒!|Tā zuì bàng!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-01.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_02.mp3"),
          word: "我要坐公共汽车。|Wǒ yào zuò gōnggòngqìchē.",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-04.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_03.mp3"),
          word: "我要过马路。|Wǒ yào guò mǎlù.",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-03.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_04.mp3"),
          word: "闪开!|Shǎnkāi!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-06.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_05.mp3"),
          word: "太危险了!|Tài wēixiǎn le!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-05.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_06.mp3"),
          word: "他插队了!|Tā chā duì le!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-08.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_07.mp3"),
          word: "你排队吧!|Nǐ pái duì ba!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-07.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_08.mp3"),
          word: "知道了。|Zhīdào le.",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-10.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_09.mp3"),
          word: "怎么办?|Zěnme bàn?",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-09.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_10.mp3"),
          word: "我带你去吧。|Wǒ dài nǐ qù ba.",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-12.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_11.mp3"),
          word: "你系安全带吧!|Nǐ jì ānquándài ba!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-11.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_12.mp3"),
          word: "叔叔, 快点儿!|Shūshu, kuài diǎnr!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-14.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_13.mp3"),
          word: "别着急!|Bié zháojí!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-13.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_14.mp3"),
          word: "太慢了!|Tài màn le!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-16.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_15.mp3"),
          word: "应该注意安全!|Yīnggāi zhùyì ānquán!",
        },
        {
          img: require("@data/assets/purple/book9/images/img_P9-15.png"),
          sound: require("@data/assets/purple/book9/sounds/KG09_W_16.mp3"),
          word: "太晚了!|Tài wǎn le!",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book9/images/img_P9-02.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_01.mp3"),
        buttons: [
          { ch2: "Tā zuì bàng!" },
          { ch: "他最棒!" },
          { ko: "최고야!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-01.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_02.mp3"),
        buttons: [
          { ch2: "Wǒ yào zuò gōnggòngqìchē." },
          { ch: "我要坐公共汽车。" },
          { ko: "버스를 타려고 해요." },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-04.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_03.mp3"),
        buttons: [
          { ch2: "Wǒ yào guò mǎlù." },
          { ch: "我要过马路。" },
          { ko: "나는 길을 건너야 해요." },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-03.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_04.mp3"),
        buttons: [{ ch2: "Shǎnkāi!" }, { ch: "闪开!" }, { ko: "비켜!" }],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-06.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_05.mp3"),
        buttons: [
          { ch2: "Tài wēixiǎn le!" },
          { ch: "太危险了!" },
          { ko: "너무 위험해!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-05.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_06.mp3"),
        buttons: [
          { ch2: "Tā chā duì le!" },
          { ch: "他插队了!" },
          { ko: "그가 새치기했어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-08.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_07.mp3"),
        buttons: [
          { ch2: "Nǐ pái duì ba!" },
          { ch: "你排队吧!" },
          { ko: "줄을 서세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-07.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_08.mp3"),
        buttons: [{ ch2: "Zhīdào le." }, { ch: "知道了。" }, { ko: "알았어." }],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-10.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_09.mp3"),
        buttons: [
          { ch2: "Zěnme bàn?" },
          { ch: "怎么办?" },
          { ko: "어떡하지?" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-09.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ dài nǐ qù ba." },
          { ch: "我带你去吧。" },
          { ko: "내가 데려 가줄게." },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-12.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_11.mp3"),
        buttons: [
          { ch2: "Nǐ jì ānquándài ba!" },
          { ch: "你系安全带吧!" },
          { ko: "안전벨트를 매세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-11.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_12.mp3"),
        buttons: [
          { ch2: "Shūshu, kuài diǎnr!" },
          { ch: "叔叔, 快点儿!" },
          { ko: "아저씨, 빨리요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-14.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_13.mp3"),
        buttons: [
          { ch2: "Bié zháojí!" },
          { ch: "别着急!" },
          { ko: "조급해 하지 마!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-13.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_14.mp3"),
        buttons: [
          { ch2: "Tài màn le!" },
          { ch: "太慢了!" },
          { ko: "너무 느려요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-16.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_15.mp3"),
        buttons: [
          { ch2: "Yīnggāi zhùyì ānquán!" },
          { ch: "应该注意安全!" },
          { ko: "안전에 주의해야 해!" },
        ],
      },
      {
        img: require("@data/assets/purple/book9/images/img_P9-15.png"),
        sound: require("@data/assets/purple/book9/sounds/KG09_W_16.mp3"),
        buttons: [
          { ch2: "Tài wǎn le!" },
          { ch: "太晚了!" },
          { ko: "너무 늦었어!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book9/sounds/KG09_W_02.mp3"),
          img: require("@data/assets/purple/book9/images/img_P9-01.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book9/sounds/KG09_W_05.mp3"),
          answer: [
            [require("@data/assets/purple/book9/images/img_P9-06.png"), true],
            [require("@data/assets/purple/book9/images/img_P9-08.png"), false],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book9/sounds/KG09_W_13.mp3"),
          answer: [
            ["别着急!", true],
            ["太晚了!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book9/pages/front.jpg"),
        sound: require("@data/assets/purple/book9/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book9/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page04.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page06.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page08.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page10.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page12.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page14.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page16.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page18.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page20.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page22.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page23.jpg"),
        sound: require("@data/assets/purple/book9/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book9/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book9/thumbnail/front.jpg"),
      require("@data/assets/purple/book9/thumbnail/page02.jpg"),
      require("@data/assets/purple/book9/thumbnail/page03.jpg"),
      require("@data/assets/purple/book9/thumbnail/page04.jpg"),
      require("@data/assets/purple/book9/thumbnail/page05.jpg"),
      require("@data/assets/purple/book9/thumbnail/page06.jpg"),
      require("@data/assets/purple/book9/thumbnail/page07.jpg"),
      require("@data/assets/purple/book9/thumbnail/page08.jpg"),
      require("@data/assets/purple/book9/thumbnail/page09.jpg"),
      require("@data/assets/purple/book9/thumbnail/page10.jpg"),
      require("@data/assets/purple/book9/thumbnail/page11.jpg"),
      require("@data/assets/purple/book9/thumbnail/page12.jpg"),
      require("@data/assets/purple/book9/thumbnail/page13.jpg"),
      require("@data/assets/purple/book9/thumbnail/page14.jpg"),
      require("@data/assets/purple/book9/thumbnail/page15.jpg"),
      require("@data/assets/purple/book9/thumbnail/page16.jpg"),
      require("@data/assets/purple/book9/thumbnail/page17.jpg"),
      require("@data/assets/purple/book9/thumbnail/page18.jpg"),
      require("@data/assets/purple/book9/thumbnail/page19.jpg"),
      require("@data/assets/purple/book9/thumbnail/page20.jpg"),
      require("@data/assets/purple/book9/thumbnail/page21.jpg"),
      require("@data/assets/purple/book9/thumbnail/page22.jpg"),
      require("@data/assets/purple/book9/thumbnail/page23.jpg"),
      require("@data/assets/purple/book9/thumbnail/page24.jpg"),
      require("@data/assets/purple/book9/thumbnail/page25.jpg"),
      require("@data/assets/purple/book9/thumbnail/page26.jpg"),
      require("@data/assets/purple/book9/thumbnail/page27.jpg"),
    ],
  },
  //10
  {
    key: "c7-10",
    title: "엄마 미안해요!",
    grade: "10권",
    cover: require("@data/assets/purple/book10/images/cover.jpg"),
    background: require("@data/assets/purple/book10/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book10/sounds/page23.mp3"),
      title: "Nǐ yào chuān nǎ ge?",
      caption: [
        "nǐ yào chuān nǎ ge nǐ yào chuān nǎ ge",
        "wǒ yào chuān hóngsè de yī fu",
        "nǐ yào chī nǎ ge nǐ yào chī nǎ ge",
        "wǒ yào chī xiāngcháng",
        "nǐ hē shuǐ ba bù wǒ xiǎng hē guǒzhī wǒ xiǎng hē niúnǎi",
        "wǒ tài guòfèn le māma duìbuqǐ wǒ yào tīng māma de huà",
      ],
    },
    mov: {
      cn: "1a660eb57f52e2e0a5e741c8995029cc_10",
      en: "5d189bd7b71fcc4e00c05ff2e005c748_10",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book10/images/img_P10-02.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_01.mp3"),
          word: "帮我穿衣服。|Bāng wǒ chuān yīfu.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-01.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_02.mp3"),
          word: "等一下。|Děng yíxià.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-04.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_03.mp3"),
          word: "你要穿哪个?|Nǐ yào chuān nǎ ge?",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-03.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_04.mp3"),
          word: "我要穿蓝色的衣服。|Wǒ yào chuān lánsè de yīfu.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-06.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_05.mp3"),
          word: "你要吃哪个?|Nǐ yào chī nǎ ge?",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-05.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_06.mp3"),
          word: "我要吃香肠。|Wǒ yào chī xiāngcháng.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-08.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_07.mp3"),
          word: "收拾一下。|Shōushi yíxià.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-07.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_08.mp3"),
          word: "你没事儿吗?|Nǐ méi shìr ma?",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-10.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_09.mp3"),
          word: "我没事儿。|Wǒ méi shìr.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-09.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_10.mp3"),
          word: "妈妈, 我帮你吧。|Māma, wǒ bāng nǐ ba.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-12.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_11.mp3"),
          word: "我很渴。|Wǒ hěn kě.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-11.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_12.mp3"),
          word: "你喝水吧!|Nǐ hē shuǐ ba!",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-14.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_13.mp3"),
          word: "不, 我想喝果汁。|Bù, wǒ xiǎng hē guǒzhī.",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-13.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_14.mp3"),
          word: "你太过分了!|Nǐ tài guòfèn le!",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-16.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_15.mp3"),
          word: "我是跟你学的!|Wǒ shì gēn nǐ xué de!",
        },
        {
          img: require("@data/assets/purple/book10/images/img_P10-15.png"),
          sound: require("@data/assets/purple/book10/sounds/KG10_W_16.mp3"),
          word: "我要听妈妈的话。|Wǒ yào tīng māma de huà.",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book10/images/img_P10-02.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_01.mp3"),
        buttons: [
          { ch2: "Bāng wǒ chuān yīfu." },
          { ch: "帮我穿衣服。" },
          { ko: "옷 입혀줘." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-01.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_02.mp3"),
        buttons: [
          { ch2: "Děng yíxià." },
          { ch: "等一下。" },
          { ko: "기다려." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-04.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_03.mp3"),
        buttons: [
          { ch2: "Nǐ yào chuān nǎ ge?" },
          { ch: "你要穿哪个?" },
          { ko: "어떤 걸 입을래?" },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-03.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_04.mp3"),
        buttons: [
          { ch2: "Wǒ yào chuān lánsè de yīfu." },
          { ch: "我要穿蓝色的衣服。" },
          { ko: "나는 파란색 옷을 입을래." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-06.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_05.mp3"),
        buttons: [
          { ch2: "Nǐ yào chī nǎ ge?" },
          { ch: "你要吃哪个?" },
          { ko: "어느 것을 먹을래?" },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-05.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ yào chī xiāngcháng." },
          { ch: "我要吃香肠。" },
          { ko: "나는 소시지를 먹을래요." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-08.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_07.mp3"),
        buttons: [
          { ch2: "Shōushi yíxià." },
          { ch: "收拾一下。" },
          { ko: "치워라." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-07.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_08.mp3"),
        buttons: [
          { ch2: "Nǐ méi shìr ma?" },
          { ch: "你没事儿吗?" },
          { ko: "너 괜찮아?" },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-10.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_09.mp3"),
        buttons: [
          { ch2: "Wǒ méi shìr." },
          { ch: "我没事儿。" },
          { ko: "괜찮아요." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-09.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_10.mp3"),
        buttons: [
          { ch2: "Māma, wǒ bāng nǐ ba." },
          { ch: "妈妈, 我帮你吧。" },
          { ko: "엄마, 제가 도와드릴게요." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-12.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_11.mp3"),
        buttons: [
          { ch2: "Wǒ hěn kě." },
          { ch: "我很渴。" },
          { ko: "목이 말라요." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-11.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_12.mp3"),
        buttons: [
          { ch2: "Nǐ hē shuǐ ba!" },
          { ch: "你喝水吧!" },
          { ko: "물을 마셔!" },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-14.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_13.mp3"),
        buttons: [
          { ch2: "Bù, wǒ xiǎng hē guǒzhī." },
          { ch: "不, 我想喝果汁。" },
          { ko: "아니, 주스 마시고 싶어." },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-13.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_14.mp3"),
        buttons: [
          { ch2: "Nǐ tài guòfèn le!" },
          { ch: "你太过分了!" },
          { ko: "너는 너무해!" },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-16.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_15.mp3"),
        buttons: [
          { ch2: "Wǒ shì gēn nǐ xué de!" },
          { ch: "我是跟你学的!" },
          { ko: "나는 너에게 배웠어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book10/images/img_P10-15.png"),
        sound: require("@data/assets/purple/book10/sounds/KG10_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ yào tīng māma de huà." },
          { ch: "我要听妈妈的话。" },
          { ko: "나는 엄마 말 들을래요." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book10/sounds/KG10_W_02.mp3"),
          img: require("@data/assets/purple/book10/images/img_P10-11.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book10/sounds/KG10_W_05.mp3"),
          answer: [
            [require("@data/assets/purple/book10/images/img_P10-06.png"), true],
            [
              require("@data/assets/purple/book10/images/img_P10-09.png"),
              false,
            ],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book10/sounds/KG10_W_11.mp3"),
          answer: [
            ["我很渴。", true],
            ["你喝水吧!", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book10/pages/front.jpg"),
        sound: require("@data/assets/purple/book10/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book10/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page04.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page06.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page08.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page10.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page12.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page14.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page16.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page18.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page20.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page22.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page23.jpg"),
        sound: require("@data/assets/purple/book10/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book10/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book10/thumbnail/front.jpg"),
      require("@data/assets/purple/book10/thumbnail/page02.jpg"),
      require("@data/assets/purple/book10/thumbnail/page03.jpg"),
      require("@data/assets/purple/book10/thumbnail/page04.jpg"),
      require("@data/assets/purple/book10/thumbnail/page05.jpg"),
      require("@data/assets/purple/book10/thumbnail/page06.jpg"),
      require("@data/assets/purple/book10/thumbnail/page07.jpg"),
      require("@data/assets/purple/book10/thumbnail/page08.jpg"),
      require("@data/assets/purple/book10/thumbnail/page09.jpg"),
      require("@data/assets/purple/book10/thumbnail/page10.jpg"),
      require("@data/assets/purple/book10/thumbnail/page11.jpg"),
      require("@data/assets/purple/book10/thumbnail/page12.jpg"),
      require("@data/assets/purple/book10/thumbnail/page13.jpg"),
      require("@data/assets/purple/book10/thumbnail/page14.jpg"),
      require("@data/assets/purple/book10/thumbnail/page15.jpg"),
      require("@data/assets/purple/book10/thumbnail/page16.jpg"),
      require("@data/assets/purple/book10/thumbnail/page17.jpg"),
      require("@data/assets/purple/book10/thumbnail/page18.jpg"),
      require("@data/assets/purple/book10/thumbnail/page19.jpg"),
      require("@data/assets/purple/book10/thumbnail/page20.jpg"),
      require("@data/assets/purple/book10/thumbnail/page21.jpg"),
      require("@data/assets/purple/book10/thumbnail/page22.jpg"),
      require("@data/assets/purple/book10/thumbnail/page23.jpg"),
      require("@data/assets/purple/book10/thumbnail/page24.jpg"),
      require("@data/assets/purple/book10/thumbnail/page25.jpg"),
      require("@data/assets/purple/book10/thumbnail/page26.jpg"),
      require("@data/assets/purple/book10/thumbnail/page27.jpg"),
    ],
  },
  //11
  {
    key: "c7-11",
    title: "풍선껌 대소동",
    grade: "11권",
    cover: require("@data/assets/purple/book11/images/cover.jpg"),
    background: require("@data/assets/purple/book11/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book11/sounds/page23.mp3"),
      title: "Zhège kǒuxiāngtáng duōshao qián?",
      caption: [
        "wā kǒuxiāngtáng kǒuxiāngtáng wǒ xǐhuan kǒuxiāngtáng",
        "zhège kǒuxiāngtáng duōshao qián yí kuài yí kuài",
        "wā bīngqílín bīngqílín wǒ yào chī bīngqílín",
        "zhè ge bīngqílín duōshao qián wǔ kuài wǔ kuài",
        "wǒ mǎi yí ge kǒuxiāngtáng yí ge bīngqílín yígòng liù kuài",
      ],
    },
    mov: {
      cn: "8413df30776404734c4186a8f106326f_11",
      en: "70f4ef6538327783e14b0f543b50e92b_11",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book11/images/img_P11-02.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_01.mp3"),
          word: "这个口香糖多少钱?|Zhège kǒuxiāngtáng duōshao qián?",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-01.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_02.mp3"),
          word: "一块。|Yí kuài.",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-04.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_03.mp3"),
          word: "这个冰淇淋多少钱?|Zhège bīngqílín duōshao qián?",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-03.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_04.mp3"),
          word: "五块。|Wǔ kuài.",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-06.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_05.mp3"),
          word: "没问题吧?|Méi wèntí ba?",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-05.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_06.mp3"),
          word: "我要进去看看。|Wǒ yào jìnqù kànkan.",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-08.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_07.mp3"),
          word: "小心!|Xiǎoxīn!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-07.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_08.mp3"),
          word: "对不起!|Duìbuqǐ!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-10.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_09.mp3"),
          word: "眼镜不见了。|Yǎnjìng bú jiàn le.",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-09.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_10.mp3"),
          word: "我的鸡蛋!|Wǒ de jīdàn!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-12.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_11.mp3"),
          word: "危险!|Wēixiǎn!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-11.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_12.mp3"),
          word: "西瓜不见了。|Xīguā bú jiàn le.",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-14.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_13.mp3"),
          word: "我的衣服脏了!|Wǒ de yīfu zāng le!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-13.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_14.mp3"),
          word: "我的鞋子脏了!|Wǒ de xiézi zāng le!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-16.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_15.mp3"),
          word: "别吵架!|Bié chǎojià!",
        },
        {
          img: require("@data/assets/purple/book11/images/img_P11-15.png"),
          sound: require("@data/assets/purple/book11/sounds/KG11_W_16.mp3"),
          word: "怎么回事儿?|Zěnme huí shìr?",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book11/images/img_P11-02.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_01.mp3"),
        buttons: [
          { ch2: "Zhège kǒuxiāngtáng duōshao qián?" },
          { ch: "这个口香糖多少钱?" },
          { ko: "이 껌은 얼마예요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-01.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_02.mp3"),
        buttons: [
          { ch2: "Yí kuài." },
          { ch: "一块。" },
          { ko: "1위안이에요." },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-04.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_03.mp3"),
        buttons: [
          { ch2: "Zhège bīngqílín duōshao qián?" },
          { ch: "这个冰淇淋多少钱?" },
          { ko: "이 아이스크림은 얼마예요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-03.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_04.mp3"),
        buttons: [
          { ch2: "Wǔ kuài." },
          { ch: "五块。" },
          { ko: "5위안이에요." },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-06.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_05.mp3"),
        buttons: [
          { ch2: "Méi wèntí ba?" },
          { ch: "没问题吧?" },
          { ko: "괜찮겠지?" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-05.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_06.mp3"),
        buttons: [
          { ch2: "Wǒ yào jìnqù kànkan." },
          { ch: "我要进去看看。" },
          { ko: "들어가 봐야겠어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-08.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_07.mp3"),
        buttons: [{ ch2: "Xiǎoxīn!" }, { ch: "小心!" }, { ko: "조심해!" }],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-07.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_08.mp3"),
        buttons: [{ ch2: "Duìbuqǐ!" }, { ch: "对不起!" }, { ko: "미안해요!" }],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-10.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_09.mp3"),
        buttons: [
          { ch2: "Yǎnjìng bú jiàn le." },
          { ch: "眼镜不见了。" },
          { ko: "안경이 없어졌어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-09.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_10.mp3"),
        buttons: [
          { ch2: "Wǒ de jīdàn!" },
          { ch: "我的鸡蛋!" },
          { ko: "내 달걀!" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-12.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_11.mp3"),
        buttons: [{ ch2: "Wēixiǎn!" }, { ch: "危险!" }, { ko: "위험해!" }],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-11.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_12.mp3"),
        buttons: [
          { ch2: "Xīguā bú jiàn le." },
          { ch: "西瓜不见了。" },
          { ko: "수박이 없어졌어." },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-14.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_13.mp3"),
        buttons: [
          { ch2: "Wǒ de yīfu zāng le!" },
          { ch: "我的衣服脏了!" },
          { ko: "내 옷이 더러워졌어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-13.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ de xiézi zāng le!" },
          { ch: "我的鞋子脏了!" },
          { ko: "내 신발이 더러워졌어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-16.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_15.mp3"),
        buttons: [
          { ch2: "Bié chǎojià!" },
          { ch: "别吵架!" },
          { ko: "싸우지 마세요!" },
        ],
      },
      {
        img: require("@data/assets/purple/book11/images/img_P11-15.png"),
        sound: require("@data/assets/purple/book11/sounds/KG11_W_16.mp3"),
        buttons: [
          { ch2: "Zěnme huí shìr?" },
          { ch: "怎么回事儿?" },
          { ko: "어떻게 된 일이에요?" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book11/sounds/KG11_W_15.mp3"),
          img: require("@data/assets/purple/book11/images/img_P11-16.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book11/sounds/KG11_W_09.mp3"),
          answer: [
            [require("@data/assets/purple/book11/images/img_P11-10.png"), true],
            [
              require("@data/assets/purple/book11/images/img_P11-11.png"),
              false,
            ],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book11/sounds/KG11_W_08.mp3"),
          answer: [
            ["小心!", false],
            ["对不起!", true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book11/pages/front.jpg"),
        sound: require("@data/assets/purple/book11/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book11/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page04.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page06.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page08.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page10.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page12.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page14.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page16.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page18.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page20.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page22.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page23.jpg"),
        sound: require("@data/assets/purple/book11/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book11/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book11/thumbnail/front.jpg"),
      require("@data/assets/purple/book11/thumbnail/page02.jpg"),
      require("@data/assets/purple/book11/thumbnail/page03.jpg"),
      require("@data/assets/purple/book11/thumbnail/page04.jpg"),
      require("@data/assets/purple/book11/thumbnail/page05.jpg"),
      require("@data/assets/purple/book11/thumbnail/page06.jpg"),
      require("@data/assets/purple/book11/thumbnail/page07.jpg"),
      require("@data/assets/purple/book11/thumbnail/page08.jpg"),
      require("@data/assets/purple/book11/thumbnail/page09.jpg"),
      require("@data/assets/purple/book11/thumbnail/page10.jpg"),
      require("@data/assets/purple/book11/thumbnail/page11.jpg"),
      require("@data/assets/purple/book11/thumbnail/page12.jpg"),
      require("@data/assets/purple/book11/thumbnail/page13.jpg"),
      require("@data/assets/purple/book11/thumbnail/page14.jpg"),
      require("@data/assets/purple/book11/thumbnail/page15.jpg"),
      require("@data/assets/purple/book11/thumbnail/page16.jpg"),
      require("@data/assets/purple/book11/thumbnail/page17.jpg"),
      require("@data/assets/purple/book11/thumbnail/page18.jpg"),
      require("@data/assets/purple/book11/thumbnail/page19.jpg"),
      require("@data/assets/purple/book11/thumbnail/page20.jpg"),
      require("@data/assets/purple/book11/thumbnail/page21.jpg"),
      require("@data/assets/purple/book11/thumbnail/page22.jpg"),
      require("@data/assets/purple/book11/thumbnail/page23.jpg"),
      require("@data/assets/purple/book11/thumbnail/page24.jpg"),
      require("@data/assets/purple/book11/thumbnail/page25.jpg"),
      require("@data/assets/purple/book11/thumbnail/page26.jpg"),
      require("@data/assets/purple/book11/thumbnail/page27.jpg"),
    ],
  },
  //12
  {
    key: "c7-12",
    title: "꾸준히, 꾸준히!",
    grade: "12권",
    cover: require("@data/assets/purple/book12/images/cover.jpg"),
    background: require("@data/assets/purple/book12/pages/page05.jpg"),
    song: {
      url: require("@data/assets/purple/book12/sounds/page23.mp3"),
      title: "Nǐ qù guo Běijīng ma?",
      caption: [
        "Zhōngguó Zhōngguó",
        "wǒ qù guo Zhōngguó wǒ qù guo Zhōngguó",
        "Běijīng Běijīng nǐ qù guo Běijīng ma",
        "wǒ qù guo wǒ qù guo",
        "Shànghǎi Shànghǎi nǐ qù guo Shànghǎi ma",
        "wǒ qù guo wǒ qù guo",
        "wǒ yě xiǎng qù Běijīng Shànghǎi",
        "wǒ yě xiǎng qù Běijīng Shànghǎi",
      ],
    },
    mov: {
      cn: "b56646a616829b06172118de7da05062_12",
      en: "3be796709910ff27969ab4efddf0a2f5_12",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/purple/book12/images/img_P12-02.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_01.mp3"),
          word: "汉语难不难?|Hànyǔ nán bu nán?",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-01.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_02.mp3"),
          word: "很难。|Hěn nán.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-04.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_03.mp3"),
          word: "奶奶，我想听故事。|Nǎinai, wǒ xiǎng tīng gùshi.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-03.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_04.mp3"),
          word: "那我给你讲故事。|Nà wǒ gěi nǐ jiǎng gùshi.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-06.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_05.mp3"),
          word: "有人吗?|Yǒu rén ma?",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-05.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_06.mp3"),
          word: "这个很像兔子。|Zhège hěn xiàng tùzi.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-08.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_07.mp3"),
          word: "那个很像大象。|Nàge hěn xiàng dàxiàng.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-07.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_08.mp3"),
          word: "这个很奇怪。|Zhège hěn qíguài.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-10.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_09.mp3"),
          word: "他们在做什么呢?|Tāmen zài zuò shénme ne?",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-09.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_10.mp3"),
          word: "我们能做到!|Wǒmen néng zuò dào!",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-12.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_11.mp3"),
          word: "不可能!|Bù kěnéng!",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-11.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_12.mp3"),
          word: "我做梦了。|Wǒ zuò mèng le.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-14.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_13.mp3"),
          word: "您去过北京吗?|Nín qù guo Běijīng ma?",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-13.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_14.mp3"),
          word: "我去过。|Wǒ qù guo.",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-16.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_15.mp3"),
          word: "您去过上海吗?|Nín qù guo Shànghǎi ma?",
        },
        {
          img: require("@data/assets/purple/book12/images/img_P12-15.png"),
          sound: require("@data/assets/purple/book12/sounds/KG12_W_16.mp3"),
          word: "我要努力学习。|Wǒ yào nǔlì xuéxí.",
        },
      ],
    },
    word: [],
    idiom: [
      {
        img: require("@data/assets/purple/book12/images/img_P12-02.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_01.mp3"),
        buttons: [
          { ch2: "Hànyǔ nán bu nán?" },
          { ch: "汉语难不难?" },
          { ko: "중국어는 어려워요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-01.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_02.mp3"),
        buttons: [{ ch2: "Hěn nán." }, { ch: "很难。" }, { ko: "어려워요." }],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-04.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_03.mp3"),
        buttons: [
          { ch2: "Nǎinai, wǒ xiǎng tīng gùshi." },
          { ch: "奶奶，我想听故事。" },
          { ko: "할머니, 이야기를 듣고 싶어요." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-03.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_04.mp3"),
        buttons: [
          { ch2: "Nà wǒ gěi nǐ jiǎng gùshi." },
          { ch: "那我给你讲故事。" },
          { ko: "그럼 내가 이야기를 해줄게." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-06.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_05.mp3"),
        buttons: [
          { ch2: "Yǒu rén ma?" },
          { ch: "有人吗?" },
          { ko: "누구 있어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-05.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_06.mp3"),
        buttons: [
          { ch2: "Zhège hěn xiàng tùzi." },
          { ch: "这个很像兔子。" },
          { ko: "이것은 토끼를 닮았다." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-08.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_07.mp3"),
        buttons: [
          { ch2: "Nàge hěn xiàng dàxiàng." },
          { ch: "那个很像大象。" },
          { ko: "그것은 코끼리를 닮았다." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-07.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_08.mp3"),
        buttons: [
          { ch2: "Zhège hěn qíguài." },
          { ch: "这个很奇怪。" },
          { ko: "이것은 이상해." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-10.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_09.mp3"),
        buttons: [
          { ch2: "Tāmen zài zuò shénme ne?" },
          { ch: "他们在做什么呢?" },
          { ko: "그들은 무엇을 하고 있을까?" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-09.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_10.mp3"),
        buttons: [
          { ch2: "Wǒmen néng zuò dào!" },
          { ch: "我们能做到!" },
          { ko: "우리는 할 수 있어!" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-12.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_11.mp3"),
        buttons: [
          { ch2: "Bù kěnéng!" },
          { ch: "不可能!" },
          { ko: "말도 안 돼!" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-11.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_12.mp3"),
        buttons: [
          { ch2: "Wǒ zuò mèng le." },
          { ch: "我做梦了。" },
          { ko: "나 꿈꿨어." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-14.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_13.mp3"),
        buttons: [
          { ch2: "Nín qù guo Běijīng ma?" },
          { ch: "您去过北京吗?" },
          { ko: "당신은 베이징에<br>가 본 적이 있어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-13.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_14.mp3"),
        buttons: [
          { ch2: "Wǒ qù guo." },
          { ch: "我去过。" },
          { ko: "나는 가봤어." },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-16.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_15.mp3"),
        buttons: [
          { ch2: "Nín qù guo Shànghǎi ma?" },
          { ch: "您去过上海吗?" },
          { ko: "당신은 상해에 가 본 적이 있어요?" },
        ],
      },
      {
        img: require("@data/assets/purple/book12/images/img_P12-15.png"),
        sound: require("@data/assets/purple/book12/sounds/KG12_W_16.mp3"),
        buttons: [
          { ch2: "Wǒ yào nǔlì xuéxí." },
          { ch: "我要努力学习。" },
          { ko: "나는 열심히 공부할 거야." },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/purple/book12/sounds/KG12_W_01.mp3"),
          img: require("@data/assets/purple/book12/images/img_P12-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/purple/book12/sounds/KG12_W_10.mp3"),
          answer: [
            [require("@data/assets/purple/book12/images/img_P12-09.png"), true],
            [
              require("@data/assets/purple/book12/images/img_P12-12.png"),
              false,
            ],
          ],
        },
        {
          type: "ty3",
          sound: require("@data/assets/purple/book12/sounds/KG12_W_13.mp3"),
          answer: [
            ["您去过北京吗?", true],
            ["我要努力学习。", false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/purple/book12/pages/front.jpg"),
        sound: require("@data/assets/purple/book12/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/purple/book12/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page04.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page06.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page08.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page10.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page12.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page14.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page16.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page18.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page20.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page22.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page23.jpg"),
        sound: require("@data/assets/purple/book12/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/purple/book12/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/purple/book12/thumbnail/front.jpg"),
      require("@data/assets/purple/book12/thumbnail/page02.jpg"),
      require("@data/assets/purple/book12/thumbnail/page03.jpg"),
      require("@data/assets/purple/book12/thumbnail/page04.jpg"),
      require("@data/assets/purple/book12/thumbnail/page05.jpg"),
      require("@data/assets/purple/book12/thumbnail/page06.jpg"),
      require("@data/assets/purple/book12/thumbnail/page07.jpg"),
      require("@data/assets/purple/book12/thumbnail/page08.jpg"),
      require("@data/assets/purple/book12/thumbnail/page09.jpg"),
      require("@data/assets/purple/book12/thumbnail/page10.jpg"),
      require("@data/assets/purple/book12/thumbnail/page11.jpg"),
      require("@data/assets/purple/book12/thumbnail/page12.jpg"),
      require("@data/assets/purple/book12/thumbnail/page13.jpg"),
      require("@data/assets/purple/book12/thumbnail/page14.jpg"),
      require("@data/assets/purple/book12/thumbnail/page15.jpg"),
      require("@data/assets/purple/book12/thumbnail/page16.jpg"),
      require("@data/assets/purple/book12/thumbnail/page17.jpg"),
      require("@data/assets/purple/book12/thumbnail/page18.jpg"),
      require("@data/assets/purple/book12/thumbnail/page19.jpg"),
      require("@data/assets/purple/book12/thumbnail/page20.jpg"),
      require("@data/assets/purple/book12/thumbnail/page21.jpg"),
      require("@data/assets/purple/book12/thumbnail/page22.jpg"),
      require("@data/assets/purple/book12/thumbnail/page23.jpg"),
      require("@data/assets/purple/book12/thumbnail/page24.jpg"),
      require("@data/assets/purple/book12/thumbnail/page25.jpg"),
      require("@data/assets/purple/book12/thumbnail/page26.jpg"),
      require("@data/assets/purple/book12/thumbnail/page27.jpg"),
    ],
  },
];
